export default "__VITE_ASSET__DO5i2b93__"